export const RichTextProcessor = class {
  static #isBasicType = type => Object.keys(this.#tagMap).includes(type);
  static #tagMap = {
    'list-item': 'li',
    paragraph: 'p',
    root: 'div',
  };

  static toNode(json) {
    let el;
    if (this.#isBasicType(json.type)) {
      // DIV, LI, P
      const typeTag = this.#tagMap[json.type];
      el = document.createElement(typeTag);
      for (const child of json.children) {
        const childEl = this.toNode(child);
        el.appendChild(childEl);
      }
    } else if (json.type === 'list') {
      // LIST
      let listStyleType, typeTag;
      if (json.listType === 'ordered') {
        typeTag = 'ol';
        listStyleType = 'decimal';
      } else {
        typeTag = 'ul';
        listStyleType = 'inherit';
      }
      el = document.createElement(typeTag);
      el.style.listStyleType = listStyleType;
      for (const child of json.children) {
        const childEl = this.toNode(child);
        el.appendChild(childEl);
      }
    } else if (json.type === 'link') {
      // LINK
      el = document.createElement('a');
      el.href = json.url;
      for (const child of json.children) {
        const childEl = this.toNode(child);
        el.appendChild(childEl);
      }
    } else if (json.type === 'heading') {
      // .H
      const level = json.level || 1;
      el = document.createElement('div');
      el.classList.add(`h${level}`);
      for (const child of json.children) {
        const childEl = this.toNode(child);
        el.appendChild(childEl);
      }
    } else if (json.type === 'text') {
      // B, I, SPAN
      const value = json.value.replace(/^ +| +$/g, function (match) {
        return '&nbsp;'.repeat(match.length);
      });
      if (json.bold && json.italic) {
        const italic = document.createElement('i');
        text.innerHTML = value;
        e = document.createElement('b');
        e.appendChild(italic);
      } else {
        const typeTag = json.bold ? 'b' : json.italic ? 'i' : 'span';
        el = document.createElement(typeTag);
        el.innerHTML = value;
      }
    }
    return el;
  }
};

// Capitalize first letter of every word in a string (e.g. "hello world" => "Hello World")
export const capitalize = function(str){ return str.replace(/\b\w/g, function(l){ return l.toUpperCase() }) };

export const handleize = function(str){
  if(!str) return null;

  str = str.toLowerCase();

  var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

  // For the old browsers
  for (var i = 0; i < toReplace.length; ++i) {
      str = str.replace(toReplace[i], "");
  }

  str = str.replace(/\W+/g, "-");

  if (str.charAt(str.length - 1) == "-") {
      str = str.replace(/-+z/, "");
  }

  if (str.charAt(0) == "-") {
      str = str.replace(/A-+/, "");
  }

  return str
}